<template>
    <v-layout justify-center>
        <v-flex sm12 lg10  mt-3>
            
            <table style="width:100%" >
                <thead style="background-color: #eee; ">
                    <th width="100">UnitId</th>
                    
                    <th width="120">Date</th>
                    <th width="120">Time</th>
                    <th width="90">Frametype</th>
                    <th width="70">EventId</th>
                    <th width="50">#Seq</th>
                    <th >Tags</th>
                </thead>
                <tr v-for='(item, i) of dataElements' :key="i">
                    <td>
                        {{ item.UnitId }}
                    </td>
                    <td>
                        {{ item.Date | date_nl  }}
                    </td>
                    <td>
                        {{ item.Time  }}
                    </td>
                    <td>
                        {{ item.Frametype }}
                    </td>
                    <td>
                        {{ item.EventId }}
                    </td>
                    <td>
                        {{ item.SequenceNumber }}
                    </td>
                    <td style="align:left;">
                        <span v-if="tags(item).length > 0">
                            <span style="margin-right:10px;" v-for="tag of tags(item)" :key="tag">{{ tag }}</span></span>
                        <span v-else><i>Geen tags aanwezig</i></span>
                    </td>
                </tr>
            </table>
        </v-flex>
    </v-layout>
</template>
<script>
import { registerChannel, registerEvent } from '../../plugins/core/dd.pusher'

export default {
    data(){
        return {
            dataElements: []
        }
    },
    methods:{
        tags(item){
            let tagArr = []
            for(let i = 1; i<=6; i++){            
                if(item[`WireCode_${i}`] && item[`WireCode_${i}`] != '0000000000000000'){
                    let tags = this.wirecodeToTags(item[`WireCode_${i}`])                    
                    for(let tag of tags){
                        if(tag != '00000000'){
                            tagArr.push(tag)
                        }
                        
                    }
                }
            }
            return tagArr
        },
        wirecodeToTags(string){
            let tag1 = string.substr(0,8);
            let tag2 = string.substr(8,15);
            console.log(string, tag1, tag2)
            return [tag1, tag2]
        }
    },
    mounted(){
        let vm = this
        registerChannel('alba-debug', {noTenant: true})
        registerEvent('alba-debug', 'incoming-data', (data) => {
            vm.dataElements.push(data)
        });
    }
}
</script>
<style>
th, td {
    text-align: center;
}
</style>